import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  ServiceFour,
  AboutOne,
  // TeamTwo,
  FaqTwo,
  AboutTwo,
  TestimonialThree,
  AboutFive,
  AboutSix,
  PricePlanOne,
  CtaOne,
  // BlogFour,
  BrandTwo,
  FooterTwo,
} from "../containers";

const Training = () => (
  <Fragment>
    <Seo
      title="SAP Training - Tech Ayukta"
      description="Tech Ayukta, in partnership with NEXTREVOL SOLUTIONS, offers industry-leading SAP Training programs for students, professionals, and corporate teams. Master SAP Functional, Technical, S/4HANA, Analytics, and Certification modules with expert trainers and hands-on real-time project experience."
      keywords="SAP Training, Tech Ayukta SAP, NEXTREVOL SOLUTIONS SAP Training, SAP Certification, SAP Functional Training, SAP Technical Training, SAP S/4HANA Training, SAP FICO Training, SAP MM Training, SAP SD Training, SAP ABAP Training, SAP Basis Training, SAP HCM Training, SAP Analytics Cloud, Corporate SAP Training, Online SAP Training, Offline SAP Training, SAP Courses for Professionals"
      canonical="https://www.techayukta.com/training"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="Training"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    {/* <ServiceFour className="space-top space-extra-bottom" /> */}
    <AboutOne className="mt-5" />
    <AboutTwo className="space-top space-extra-bottom" />
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <AboutSix className="space" />
    <AboutFive className="space-top space-extra-bottom" />
    {/* <TestimonialThree className="space-top space-extra-bottom" /> */}
    <PricePlanOne className=" space-extra" />
    <FaqTwo className="mt-5" />
    <CtaOne className="space" />
    <BrandTwo className="space" />
    {/* <BlogFour className="space-top space-extra-bottom"/> */}
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Training;
